import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { createSelectors } from "../core/utils/create-selectors";
import { AuthStore, AuthStoreActions, User } from "./types";
import { queryClient } from "@data/lib";
import { useGroupStore } from "../groups/model";
import { useServiceStore } from "../services/model";

const initialState: AuthStore = {
  user: null,
  isAuthenticated: false,
  isAdmin: false,
  token: undefined,
  refreshToken: undefined
};

const useAuthStoreBase = create(
  persist<AuthStore & AuthStoreActions>(
    (set) => ({
      ...initialState,
      updateUser: (user: User) => set(() => ({ user })),
      reset: () => set(() => ({ ...initialState })),
      login: (token: string, refreshToken: string) => {
        set(() => ({ token, refreshToken, isAuthenticated: true }));
      },
      logout: () => {
        queryClient.cancelQueries();
        queryClient.clear();
        useGroupStore.getState().reset();
        useServiceStore.getState().reset();
        useGroupStore.persist.clearStorage();
        useServiceStore.persist.clearStorage();
        localStorage.removeItem("group-storage");
        localStorage.removeItem("service-store");
        localStorage.removeItem("service-storage");
        set(() => ({ ...initialState }));
      }
    }),
    {
      name: "auth-storage", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage) // (optional) by default, 'localStorage' is used
    }
  )
);

export const useAuthStore = createSelectors(useAuthStoreBase);
